import api from "./api.service";

export const buscarPersonaReniec = (params: {
  nombre: string;
  paterno: string;
  materno?: string;
  sin_materno?: boolean;
}) => api.get("/seeker/buscar", { params });

export const buscarTelefonosReniec = (dni: string) =>
  api.get(`/seeker/dni-externa/${dni}`);


export const buscarTelefonoPorDni = (dni: string) =>
  api.get(`/seeker/dni/${dni}`);

export const buscarDniPorNombres = (nombres: string) =>
  api.get(`/seeker/nombres/${encodeURIComponent(nombres)}`);
